import apiClient from '@/api/client';
import type { ModerationResult, ModerationAuditEntry, ModerationOverrideRequest } from '@/types/moderation';

export const getPendingModerations = async (offset = 0, limit = 50): Promise<ModerationResult[]> => {
  const response = await apiClient.get('/moderation/pending', {
    params: { offset, limit },
  });
  const data = response.data;
  return Array.isArray(data) ? data : [];
};

export const getModerationResult = async (offerId: number): Promise<ModerationResult> => {
  const response = await apiClient.get<ModerationResult>(`/moderation/offers/${offerId}`);
  return response.data;
};

export const getModerationHistory = async (offerId: number): Promise<ModerationAuditEntry[]> => {
  const response = await apiClient.get<ModerationAuditEntry[]>(`/moderation/offers/${offerId}/history`);
  return response.data;
};

export const overrideModeration = async (data: ModerationOverrideRequest): Promise<void> => {
  await apiClient.post('/moderation/override', data);
};
